import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initJourneyTracker, onRouteChange } from "@/lib/journey/tracker";

/**
 * Session 37 · Phase 2 · JourneyProvider
 *
 * Wird einmal in <App /> gemountet. Reagiert auf SPA-Routenwechsel und
 * benachrichtigt den Tracker. Ersetzt den alten JourneyLandingTracker.
 */
export default function JourneyProvider() {
  const location = useLocation();

  // Boot einmalig
  useEffect(() => {
    initJourneyTracker();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Route-Change → Tracker informieren
  useEffect(() => {
    onRouteChange(location.pathname + (location.search || ""));
  }, [location.pathname, location.search]);

  return null;
}
